import styled, { css } from "styled-components";
import { units, variant } from "@m/alchemy-theme";
import { Card } from "./Card.styled";
export const CardGroup = styled(Card) `
  display: ${({ display }) => display};
  align-items: stretch;
  justify-content: flex-start;
  flex-direction: ${({ layout }) => layout};
  flex-wrap: ${({ isJoined }) => (isJoined ? "nowrap" : "wrap")};
  gap: ${({ isJoined, layout }) => (!isJoined && layout === "row" ? `${units(1)}` : "0")};
  overflow: visible;

  ${Card} {
    flex-grow: 1;
  }

  ${(props) => css `
    ${variant("layout", {
    column: css `
        width: 100%;

        ${props.isJoined
        ? css `
              > ${Card}:not(:last-child) {
                margin-bottom: -1px;
              }

              > ${Card}:not(:first-child):not(:last-child) {
                border-radius: 0;
              }

              > ${Card}:first-child {
                border-bottom-left-radius: 0;
                border-bottom-right-radius: 0;
              }

              > ${Card}:last-child {
                margin-bottom: 0;
                border-top-left-radius: 0;
                border-top-right-radius: 0;
              }
            `
        : css `
              > ${Card}:not(:last-child) {
                margin-bottom: ${units(1)};
              }
            `};

        ${props.hasPadding &&
        css `
          padding: ${units(3)};
        `};
      `,
    row: css `
        flex-basis: 0;

        ${props.isJoined &&
        css `
          > ${Card}:not(:last-child) {
            margin-right: -1px;
          }

          > ${Card}:not(:first-child):not(:last-child) {
            border-radius: 0;
          }

          > ${Card}:first-child {
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
          }

          > ${Card}:last-child {
            margin-right: 0;
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
          }
        `};

        ${props.hasPadding &&
        css `
          padding: ${units(3)};
        `};
      `
})};
  `};
`;
